import { Injectable } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { Observable, combineLatest, BehaviorSubject } from 'rxjs';

import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import type firebase from 'firebase/compat/';

import * as firebase_ from 'firebase/compat/app';

import { switchMap } from 'rxjs/operators';

export interface Todo {
  id?: string;
  task: string;
  priority: number;
  createdAt: number;
}

export interface DocumentChangeAction {
  type: firebase.firestore.DocumentChangeType;
  payload: firebase.firestore.DocumentChange;
}

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {

  private todosCollection: AngularFirestoreCollection<any>;

  private todos: Observable<any[]>;

  tutorialsRef: AngularFirestoreCollection<any> = null;

  // Firestore variables
  private userCollection: AngularFirestoreCollection<any>;
  users: Observable<any[]>;

  gwt_sensors: Observable<any[]>;
  sensors: Observable<any[]>;

  private userDoc: AngularFirestoreDocument<any>;
  user: Observable<any>;

  usersCollection$: BehaviorSubject<AngularFirestoreCollection<{}>>;
  users$: Observable<DocumentChangeAction[]>;

  organizationsCollection$: BehaviorSubject<AngularFirestoreCollection<{}>>;
  organizationsToIgnoreFilter$: BehaviorSubject<string|null>;
  organizations$: Observable<DocumentChangeAction[]>;

  organizationFilter$: BehaviorSubject<string|null>;
  startAtFilter$: BehaviorSubject<string|null>;
  endAtFilter$: BehaviorSubject<string|null>;

  firstLastReportCollection$: BehaviorSubject<AngularFirestoreCollection<{}>>;
  firstLastSensorReport$: Observable<DocumentChangeAction[]>;
  firstLastReportFilter$: BehaviorSubject<string|null>;


  constructor(private firestore: AngularFirestore) {

    this.organizationFilter$ = new BehaviorSubject(null);
    this.firstLastReportFilter$ = new BehaviorSubject(null);
    this.organizationsToIgnoreFilter$ = new BehaviorSubject(null);

    // Users
    combineLatest([this.organizationsToIgnoreFilter$])
    .pipe(map(filters => this.usersCollectionFromFilters(filters))).subscribe(filteredCollection => {
      if (this.usersCollection$ == null) {
        // Initialize the BehaviorSubject
        this.usersCollection$ = new BehaviorSubject(filteredCollection);
      } else {
        this.usersCollection$.next(filteredCollection);
      }
    });
    this.users$ = this.usersCollection$.pipe(switchMap(itemsCollection =>
      itemsCollection.snapshotChanges()
    ));

    // Organizations
    combineLatest([this.organizationFilter$])
    .pipe(map(filters => this.organizationsCollectionFromFilters(filters))).subscribe(filteredCollection => {
      if (this.organizationsCollection$ == null) {
        // Initialize the BehaviorSubject
        this.organizationsCollection$ = new BehaviorSubject(filteredCollection);
      } else {
        this.organizationsCollection$.next(filteredCollection);
      }
    });
    this.organizations$ = this.organizationsCollection$.pipe(switchMap(itemsCollection =>
      itemsCollection.snapshotChanges()
    ));
  }

  usersCollectionFromFilters([filter]) {
    return this.firestore.collection('users', ref => {
      let query : firebase.firestore.Query = ref;

      if (filter) {
        //console.log(filter)
        query = query.where('organization', 'not-in', filter)
        // query.get().then((snap)=>{
        //   snap.forEach((doc)=>{
        //     //console.log(doc.data()['organization'])
        //   })
        // })
      };

      return query;
    });
  }

  organizationsCollectionFromFilters([name]) {
    return this.firestore.collection('organizations', ref => {
      let query : firebase.firestore.Query = ref;

      if (name) {
        //console.log(name)
        query = query.where('name', 'not-in', name)
      };

      return query;
    });
  }

  filterBy(organization: string | null, toFilter: string | null) {
    if (toFilter === "users"){
      this.organizationFilter$.next(organization);
    }
  }

  getCollectionOnChange(path) {
    return this.firestore.collection(path).snapshotChanges().pipe(
      map(
        changes => {
          return changes.map(
            a => {
              const data: any = a.payload.doc.data();
              data.id = a.payload.doc['id'];
              return data;
            });
        })
    );
  }

  getCollection(path) {
    return this.firestore.firestore.collection(path).doc()
  }

  getDocOnChange(collection,docId) {

    return this.firestore.doc(`${collection}/${docId}`).snapshotChanges().pipe(map(changes => {
      const data = changes.payload.data();
      const id = changes.payload.id;
      return data;
    }));
  }

  updateDocs(collection, docId, dataToUpdate){
    //console.log(collection)
    //console.log(docId)
    //console.log(dataToUpdate)

    const docRef = this.firestore.firestore.collection(collection).doc(docId)
    //console.log(docRef)
    return docRef.set(dataToUpdate, {
      merge: true
    })
  }

  createDocs(collection, dataToSet){

    const docRef = this.firestore.firestore.collection(collection)

    docRef.add(dataToSet)
  }

  createPerm(collection, dataToSet, id){
    const docRef = this.firestore.firestore.collection(collection)

    docRef.doc(id).set(dataToSet, {merge: true})
  }

  deleteDocs(collection, docId){

    const docRef = this.firestore.firestore.collection(collection).doc(docId)

    docRef.delete()
  }

  getDoc(collection, docId){
    let docref = this.firestore.firestore.collection(collection)

    let doc = docref.doc(docId).get().then(doc => {
      //console.log(doc.id)
      //console.log(doc.data())
      return { id: doc.id, data: doc.data() }
    }).catch(err => {
      console.log("Error getting documents", err);
    })
    return doc
  }

  fieldValueDelete(){
    return firebase_.default.firestore.FieldValue.delete()
  }

  filterByDateTime(dateTime: string | null) {
    this.startAtFilter$.next(new Date(dateTime[0]).toISOString());
    this.endAtFilter$.next(new Date(dateTime[1]).toISOString());
  }

  /*deleteDocs(docId){
    let docref = this.firestore.firestore.collection('sensors')

    let ref = docref.doc(docId).collection("dataReport")

    ref.onSnapshot(snapshot => {
      snapshot.docs.forEach(doc => {
        ref.doc(doc.id).delete()
        .catch(error => {
          console.log(error)
        })
      })
    })
  }*/
}
